import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visituser: {
    name: '',
    phone: '',
  },
};

export const VisitSlice = createSlice({
  name: 'Visit',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // builder.addCase(fetchUserById.pending, (state) => {
    //   state.userDetail.loading = true;
    //   state.userDetail.error = '';
    // });
  },
});

export default VisitSlice.reducer;